import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-path": "url(#a)",
      "clip-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M12.297 9.871a.61.61 0 0 1 .745-.439 3.055 3.055 0 0 1 2.291 2.956v1.223a.611.611 0 0 1-1.222 0V12.39a1.834 1.834 0 0 0-1.375-1.773.61.61 0 0 1-.439-.745M1.562 10.228a3.06 3.06 0 0 1 2.16-.895h4.89a3.056 3.056 0 0 1 3.055 3.056v1.222a.611.611 0 0 1-1.223 0V12.39a1.833 1.833 0 0 0-1.833-1.833H3.722a1.833 1.833 0 0 0-1.833 1.833v1.222a.611.611 0 0 1-1.222 0V12.39c0-.81.322-1.588.895-2.16M9.852 2.539a.61.61 0 0 1 .744-.44 3.056 3.056 0 0 1 0 5.92.611.611 0 0 1-.303-1.184 1.833 1.833 0 0 0 0-3.553.61.61 0 0 1-.44-.743M6.167 3.222a1.833 1.833 0 1 0 0 3.667 1.833 1.833 0 0 0 0-3.667M3.11 5.056a3.056 3.056 0 1 1 6.111 0 3.056 3.056 0 0 1-6.11 0" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M0 0h16v16H0z"
        })
      ])
    ], -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })